module.exports = __webpack_public_path__ + "img/2.acf1c8ee.png";